export default "__VITE_ASSET__SlCwKFEpiqWwLzUj_Ju8hw__";